// identifies user agent / operating system / device

window.UserAgentInfo = {};

window.UserAgentInfo.osname = "unknown";
if (navigator.appVersion.indexOf("Win") != -1)
  window.UserAgentInfo.osname = "windows";
if (navigator.appVersion.indexOf("Mac") != -1)
  window.UserAgentInfo.osname = "macos";
if (navigator.appVersion.indexOf("X11") != -1)
  window.UserAgentInfo.osname = "unix";
if (navigator.appVersion.indexOf("Linux") != -1)
  window.UserAgentInfo.osname = "linux";

window.UserAgentInfo.userAgent = (function () {
  var ua = navigator.userAgent,
    tem,
    M =
      ua.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return "IE " + (tem[1] || "");
  }
  if (M[1] === "Chrome") {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
  return M.join(" ");
})();

function isMobileDevice() {
  var match = window.matchMedia || window.msMatchMedia;
  if (match) {
    var mq = match("(pointer:coarse)");
    return mq.matches;
  }
  return false;
}
function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
}
function GetIOSDeviceVersion() {
  var agent = window.navigator.userAgent,
    start = agent.indexOf("OS ");
  let os_version = agent.substr(start + 3, 5).replace("_", ".");
  return os_version;
}
function doesCurrentIOSDeviceSupportSIMD() {
  var agent = window.navigator.userAgent,
    start = agent.indexOf("OS ");
  let os_version = agent.substr(start + 3, 5).replace("_", ".");
if (os_version.includes("_")) {
  os_version = os_version.replace(/[^\d.]/g,'');
}
  if (Number(os_version) > 16.4) {
    return true;
  } else {
    return false;
}
}
function getIphoneOSVersion(){
    var agent = window.navigator.userAgent,
    start = agent.indexOf("OS ");
    let os_version = agent.substr(start + 3, 5).replace("_", ".");
    if (os_version.includes("_")) {
      os_version = os_version.replace(/[^\d.]/g,'');
    }
    return os_version;
}
function IsSafariBrowser() {
  let os_info = window.UserAgentInfo.userAgent;
  let os_name = os_info.split(" ");
  if (os_name[0].toLowerCase().indexOf("safari") > -1) {
    return true;
  } else {
    return false;
  }
}
function doesCurrentSafariSupportSIMD() {
  let os_info = window.UserAgentInfo.userAgent;
  let os_name = os_info.split(" ");

  if (Number(os_name[1]) > 16) {
    return true;
  } else {
    return false;
  }
}
function IsChromeBrowser() {
    let os_info = window.UserAgentInfo.userAgent;
    let os_name = os_info.split(" ");
    if (os_name[0].toLowerCase().indexOf("chrome") > -1) {
      return true;
    } else {
      return false;
    }
  }
  function doesCurrentChromeSupportSIMD() {
    let os_info = window.UserAgentInfo.userAgent;
    let os_name = os_info.split(" ");
    if (Number(os_name[1]) > 91) {
      return true;
    } else {
      return false;
    }
  }


window.UserAgentInfo.platform = navigator.platform.toLowerCase();
